import { useState } from 'react';
import { useMutation } from '@tanstack/react-query';
import { api } from '../api/client';
import { Modal } from './Modal';
import { toast } from '../stores/toasts';

interface ReviewModalProps {
  orderId: string;
  onClose: () => void;
  onDone: () => void;
}

export function ReviewModal({ orderId, onClose, onDone }: ReviewModalProps) {
  const [rating, setRating] = useState(5);
  const [text, setText] = useState('');

  const submit = useMutation({
    mutationFn: () => api.createReview(orderId, { rating, text: text || undefined }),
    onSuccess: () => {
      toast.success('Rahmat! Bahoyingiz qabul qilindi');
      onDone();
      onClose();
    },
    onError: (e: any) => toast.error(e?.message || 'Xatolik'),
  });

  return (
    <Modal
      open
      onClose={onClose}
      title="⭐ Baho berish"
      footer={
        <>
          <button className="btn" onClick={onClose}>Bekor</button>
          <button className="btn btn-primary" onClick={() => submit.mutate()} disabled={submit.isPending}>
            {submit.isPending ? 'Yuborilmoqda...' : 'Yuborish'}
          </button>
        </>
      }
    >
      <div className="muted" style={{ marginBottom: 10, fontSize: 13 }}>Xizmat sifati qanday edi?</div>
      <div className="row" style={{ justifyContent: 'center', gap: 6, marginBottom: 14 }}>
        {[1, 2, 3, 4, 5].map((n) => (
          <button
            key={n}
            className="btn btn-ghost"
            style={{ fontSize: 30, padding: 4, color: n <= rating ? '#ffb400' : 'var(--text-dim)' }}
            onClick={() => setRating(n)}
          >
            {n <= rating ? '★' : '☆'}
          </button>
        ))}
      </div>
      <div className="field">
        <label className="field-label">Izoh (ixtiyoriy)</label>
        <textarea
          rows={4}
          placeholder="Tajribangizni baham ko'ring..."
          value={text}
          onChange={(e) => setText(e.target.value)}
        />
      </div>
    </Modal>
  );
}
